import init from "./host.js";
init();
